import { ProfileView } from "@authory-packages/core";
import styled from "styled-components";
import { getV3ContentDimension } from "../../utils/getV3ContentDimension";
import { media } from "../../theme";

export const CollectionMetaSizer = styled.div<{ $viewType: ProfileView, $isStandaloneCollectionView: boolean }>`
    margin: 0 auto;
    max-width: ${({ $viewType }) => `${getV3ContentDimension($viewType, false)}px`};
    width: 100%;
    
    ${media.tablet} {
        padding: ${({ $isStandaloneCollectionView }) =>  $isStandaloneCollectionView ? "0 18px" : undefined};
    }
`;

export const CollectionPublicSpacer = styled.div`
    padding: 22px;
    display: flex;
    flex-direction: column;

    > div {
        background: ${({ theme }) => theme.customization.backgroundColor};
        border-radius: 19px;
        
        &:nth-child(1) {
            margin-bottom: 6px;
        }
    }
`;